import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { RoleNames, RoutePaths } from '../shared/api/types/enums';
import { platformStaffGuard } from '../shared/guards/platform-staff.guard';
import { RoleGuard } from '../shared/guards/role.guard';

// Admin
export const adminRoutes: Routes = [
  {
    path: RoutePaths.AdminBackofficeUsers,
    loadChildren: () =>
      import('src/app/admin/backoffice-users/backoffice-users.module').then((mod) => mod.BackofficeUsersModule),
    data: { role: [RoleNames.role, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.AdminValueset,
    loadChildren: () => import('src/app/admin/value-set/value-set.module').then((mod) => mod.ValueSetModule),
    data: { role: [RoleNames.configuration, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.AdminAttributes,
    loadChildren: () => import('src/app/admin/attributes/attributes.module').then((mod) => mod.AttributesModule),
    data: { role: [RoleNames.configuration, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.AdminDataImport,
    loadChildren: () => import('src/app/admin/data-import/data-import.module').then((mod) => mod.DataImportModule),
    data: { role: [RoleNames.configuration, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.AdminAgents,
    loadChildren: () => import('src/app/admin/agents/agents.module').then((mod) => mod.AgentsModule),
    data: { role: [RoleNames.configuration, RoleNames.backoffice] },
    // Guarded like every sibling. Without AuthGuard the page was built before Firebase restored the
    // session on a cold load, so its first query was refused locally ('No user logged in') and the
    // listing opened on its error state; without RoleGuard the declared roles were never enforced.
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.AdminApiKeys,
    loadChildren: () =>
      import('src/app/admin/api-key-management/api-key-management.module').then((mod) => mod.ApiKeyManagementModule),
    data: { role: [RoleNames.apikey, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.AdminSearchIndex,
    loadComponent: () =>
      import('src/app/admin/search-index/search-index.component').then((mod) => mod.SearchIndexComponent),
    canActivate: [AuthGuard, platformStaffGuard]
  }
];
